import React, { useEffect } from 'react';
import clsx from 'clsx';
import styles from './styles.css.js';
import InternalIcon from '../../icon/internal';
import ItemsList from '../items-list';
import Dropdown from '../../internal/components/dropdown';
var ExpandableCategoryElement = function (_a) {
    var _b, _c;
    var item = _a.item, onItemActivate = _a.onItemActivate, onGroupToggle = _a.onGroupToggle, targetItem = _a.targetItem, isHighlighted = _a.isHighlighted, isExpanded = _a.isExpanded, highlightItem = _a.highlightItem, disabled = _a.disabled, expandToViewport = _a.expandToViewport, variant = _a.variant;
    var highlighted = isHighlighted(item);
    var expanded = isExpanded(item);
    var triggerRef = React.useRef(null);
    useEffect(function () {
        if (triggerRef.current && highlighted && !expanded) {
            triggerRef.current.focus();
        }
    }, [expanded, highlighted]);
    var triggerClickHandler = function (e) {
        if (!disabled) {
            e.preventDefault();
            onGroupToggle(item, e);
            if (triggerRef.current) {
                triggerRef.current.focus();
            }
        }
    };
    var onHover = function (event) {
        event.preventDefault();
        !disabled && highlightItem(item);
    };
    var trigger = item.text && (React.createElement("p", { onClick: triggerClickHandler, className: clsx(styles.header, styles['expandable-header'], styles["variant-" + variant], (_b = {},
            _b[styles.disabled] = disabled,
            _b[styles.highlighted] = highlighted,
            _b)), "data-testid": item.id, 
        // We are using the roving tabindex technique to manage the focus state of the dropdown.
        // The current element will always have tabindex=0 which means that it can be tabbed to,
        // while all other items have tabindex=-1 so we can focus them when necessary.
        tabIndex: item.disabled ? undefined : highlighted ? 0 : -1, ref: triggerRef },
        item.text,
        React.createElement("span", { className: clsx(styles['expand-icon'], styles['expand-icon-right']) },
            React.createElement(InternalIcon, { name: "caret-down-filled" }))));
    // Hide the category title element from screen readers because it will be
    // provided as an ARIA label.
    return (React.createElement("li", { className: clsx(styles.category, styles.expandable, (_c = {},
            _c[styles.expanded] = expanded,
            _c[styles.disabled] = disabled,
            _c[styles.highlighted] = highlighted,
            _c)), role: "menuitem", "aria-haspopup": true, "aria-expanded": expanded, "aria-disabled": disabled ? 'true' : undefined, onMouseEnter: !disabled ? onHover : undefined, onTouchStart: !disabled ? onHover : undefined },
        React.createElement(Dropdown, { open: expanded, stretchWidth: false, interior: true, expandToViewport: expandToViewport, trigger: trigger }, item.items && expanded && (React.createElement("ul", { role: "menu", "aria-label": item.text, className: clsx(styles['items-list-container']) },
            React.createElement(ItemsList, { items: item.items, onItemActivate: onItemActivate, onGroupToggle: onGroupToggle, targetItem: targetItem, isHighlighted: isHighlighted, isExpanded: isExpanded, highlightItem: highlightItem, categoryDisabled: disabled, variant: variant }))))));
};
export default ExpandableCategoryElement;
//# sourceMappingURL=expandable-category-element.js.map